<script>
export default {
  name: "emailUsSectionLight",
  data() {
    return {
      activeNames: ["1"],
      contactEmail: "team@unifiproperty.com"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Contact Us";
  },
  methods: {
    handleChange(val) {
      console.log(val);
    }
  }
};
</script>

<template>
  <el-row
    style="padding: 10px 15px 30px 15px; background-color: #fff; margin: 0"
  >
    <el-col
      :span="24"
      style="margin-top: 22px; display: flex;flex-direction: column; justify-content: center; align-items: start"
    >
      <span class="get-in-touch-email-text">If you have any questions, feel free to email us</span>
      <a style="width: 100%" target="_blank" v-bind:href="'mailto:' + contactEmail">
        <el-button class="btn-primary">{{contactEmail}}</el-button>
      </a>
    </el-col>
  </el-row>
</template>

<style scoped>
.get-in-touch-title {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.get-in-touch-desc {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.get-in-touch-email-text{
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 25px;
  font-family: DINosaur-a;
  padding-right: 20px;
  padding-bottom: 20px;
}

.get-in-touch-para {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}

.font-color {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}

.btn-primary {
  color: #fff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  //padding: 14px 60px;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  font: 500 20px DINosaur-a, sans-serif;
  border-radius: 5px;
}

.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #fff;
  color: #003333;
}

.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #fff;
}

.el-collapse-item /deep/ .el-collapse-item__content {
  color: #fff;
}

.font-style-collapse {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.font-style-desc {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}

@media (max-width: 817px) {
  .get-in-touch-title {
    font-size: 11px;
  }
  .get-in-touch-desc {
    font-size: 10px;
  }

  .btn-primary{
    font-size: 16px;
  }

}
@media (max-width: 520px) {
  .get-in-touch-title {
    font-size: 11px;
  }
  .get-in-touch-desc {
    font-size: 10px;
  }
  .btn-primary{
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact/emailUsSectionLight.vue